export const PermissionConfig = {
    PUT: "mgr-config-PUT",
    GET: "mgr-config-GET",
};